import React, { Fragment, useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import AlertToast from './components/layout/AlertToast';
import SwipeableDrawer from './components/layout/SwipeableDrawer';
//import Landing from './components/layout/Landing';
import TheRoutes from './components/routing/Routes';
import { isEmbedSearch } from './utils/embedMode';

// Redux
import { Provider } from 'react-redux';
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

import {
    createTheme,
    ThemeProvider,
    StyledEngineProvider,
    // adaptV4Theme,
} from '@mui/material/styles';

//Consider checking out material-ui and https://material-kit-pro-react.devias.io/
import './App.css';

import { library } from '@fortawesome/fontawesome-svg-core';
// import { fab } from '@fortawesome/free-brands-svg-icons';
import {
    faApple,
    faBandcamp,
    faBluesky,
    faDiscord,
    faFacebookF,
    faGoogle,
    faGoogleDrive,
    faInstagram,
    faLinktree,
    faLinkedinIn,
    faPatreon,
    faSoundcloud,
    faSpotify,
    faThreads,
    faTiktok,
    faTwitch,
    faVimeoV,
    faXTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
    faGlobeAmericas,
    faGuitar,
    faCalendarDay,
    faAllergies,
    faExternalLinkAlt,
    faBook,
} from '@fortawesome/free-solid-svg-icons';

import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
    'be0a5656909f29aa64a8bb425191b715Tz04NjcyNCxFPTE3NDI0MTg3NjEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

library.add(
    faApple,
    faBandcamp,
    faBluesky,
    faDiscord,
    faFacebookF,
    faGoogle,
    faGoogleDrive,
    faInstagram,
    faLinktree,
    faLinkedinIn,
    faPatreon,
    faSoundcloud,
    faSpotify,
    faThreads,
    faTiktok,
    faTwitch,
    faVimeoV,
    faXTwitter,
    faYoutube,
    faGlobeAmericas,
    faGuitar,
    faCalendarDay,
    faAllergies,
    faExternalLinkAlt,
    faBook
);

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#6f8785',
        },
        secondary: {
            main: '#fb9c4d',
        },
    },
    typography: {
        fontFamily: 'Merriweather',
    },
});

if (localStorage.token) {
    setAuthToken(localStorage.token);
}

const AppLayout = () => {
    const location = useLocation();
    const embed = isEmbedSearch(location.search);
    useEffect(() => {
        document.body.classList.toggle('embedMode', embed);
        return () => document.body.classList.remove('embedMode');
    }, [embed]);
    return (
        <Fragment>
            {!embed && <Navbar />}
            {!embed && <SwipeableDrawer className="porchlightBG" />}
            <TheRoutes />
            <AlertToast />
        </Fragment>
    );
};

const App = () => {
    useEffect(() => {
        store.dispatch(loadUser());
    }, []);

    // When the verify-email page (usually another tab) completes verification,
    // it sets pl:emailVerifiedAt in localStorage. Reload the user here so the
    // navbar/dashboard "verify your email" nags clear without a refresh.
    useEffect(() => {
        const onStorage = (e) => {
            if (
                e.key === 'pl:emailVerifiedAt' &&
                e.newValue &&
                localStorage.token
            ) {
                store.dispatch(loadUser());
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);
    return (
        <Provider store={store}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={darkTheme}>
                    <Router>
                        <AppLayout />
                    </Router>
                </ThemeProvider>
            </StyledEngineProvider>
        </Provider>
    );
};

export default App;
